/* istanbul ignore file */
import { useExperimentFlag } from '@zenbusiness/application-commons-experiments';

import useGetLogoUsersQuery from '#client/pages/MarketingTools/utils/hooks/useGetLogoUsersQuery';

/**
 * Return the menu config for the Logo Builder TR Test Menu Item of the current Business Entity.
 * @returns {{
 *  isLBTRTestEnabled: boolean
 *  isLBTRTestActive: boolean
 * }}
 */
export function useLogoBuilderConfig() {
  const { isLoading, logoUsersCount } = useGetLogoUsersQuery();

  // isLBTRTestEnabled - Turns on/off the Logo TR Test features
  const isLBTRTestEnabled = useExperimentFlag('enable-logo-builder-tr-test', false);
  // lbTRTestMaxUsers - Used to control if the Logo TR Test is active or inactive
  const lbTRTestMaxUsers = useExperimentFlag('logo-tr-test-users', 250);

  const isLBTRTestActive = (() => {
    if (!isLoading) {
      return logoUsersCount < lbTRTestMaxUsers;
    }
    return false;
  })();

  return {
    isLBTRTestEnabled,
    isLBTRTestActive
  };
}
